import { ToastModule } from 'primeng/toast';

import { Component, effect, inject, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular/standalone';

import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, ToastModule],
})
export class AppComponent implements OnInit {
  private readonly platform = inject(Platform);
  private readonly authService = inject(AuthService);

  constructor() {
    effect(() => {
      const member = this.authService.member();
      if (!member) {
        this.authService.loadMemberData().subscribe(() => {
          console.log('Member loaded successfully');
        });
      }
    });
  }

  async ngOnInit(): Promise<void> {
    await this.platform.ready().then(async () => {
      console.log('Platform is ready');
      await this.authService.restore();
    });
  }
}
